import { render } from "./FormDisplayField.vue?vue&type=template&id=286fb0ce&scoped=true"
import script from "./FormDisplayField.vue?vue&type=script&lang=js"
export * from "./FormDisplayField.vue?vue&type=script&lang=js"

import "./FormDisplayField.vue?vue&type=style&index=0&id=286fb0ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286fb0ce"]])

export default __exports__